import _ from "underscore";

export function getCurrentUser(state) {
    return state.UserReducer.user;
}

export function getUsers(state) {
    return state.UserReducer.users;
}
